<template>
  <div class="address-form card">
    <div class="card-header" v-if="headerText">
      <h5 class="mb-0 d-inline-block">{{ headerText }}</h5>
      <b-button class="float-right pl-2 pr-0 pt-0 pb-0" variant="link"
                v-if="showCreateAction && $hasPermission('change_customeraddress')"
                @click="showAddressModal({source: source, object: {type: type}})">
        <font-awesome-icon :icon="'plus'" style="font-size: .9em"></font-awesome-icon>
        {{ $t('New Address') }}
      </b-button>
      <b-button class="float-right p-0" variant="link" v-if="showEditAction && $hasPermission('change_customeraddress')"
                @click="showAddressModal({source: source, object: address})">
        <font-awesome-icon :icon="'pen'" style="font-size: .9em"></font-awesome-icon>
        {{ $t('Edit') }}
      </b-button>
    </div>
    <spinner :with-text="false" :show="loader" :height="9"/>
    <div class="card-body pt-0 pb-0" style="position: relative">
      <template v-if="address.address_1">
        <div v-b-tooltip.hover.left="$t('Primary')" style="position: absolute;right: 2px;z-index: 10;top: -2px;">
          <font-awesome-icon :icon="'star'" class="yellow-primary-color" v-if="address.is_primary && !hideIcon"/>
        </div>
        <div class="row">
          <div class="col-sm-5" style="padding-top: 1em">
            <p>{{ $t('Address 1') }}:</p>
          </div>
          <div class="col-sm-7" style="padding-top: 1em">
            <p>{{ address.address_1 }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <p>{{ $t('Address 2') }}:</p>
          </div>
          <div class="col-sm-7">
            <p>{{ address.address_2 }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <p>{{ $t('City') }}:</p>
          </div>
          <div class="col-sm-7">
            <p>{{ address.city }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <p>{{ $t('County') }}:</p>
          </div>
          <div class="col-sm-7">
            <p>{{ address.county }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <p>{{ $t('State') }}:</p>
          </div>
          <div class="col-sm-7">
            <p>{{ address.state }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <p>{{ $t('Zip Code') }}:</p>
          </div>
          <div class="col-sm-7">
            <p>{{ address.zip_code }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <p>{{ $t('Country') }}:</p>
          </div>
          <div class="col-sm-7">
            <p v-if="address.country_code">{{ address.country_code | countryNameByCode }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <p>{{ $t('Email') }}:</p>
          </div>
          <div class="col-sm-7">
            <p>{{ address.email }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <p>{{ $t('Phone') }}:</p>
          </div>
          <div class="col-sm-7">
            <p>{{ address.phone }}</p>
          </div>
        </div>
        <div class="row" style="margin-top: 1.5em" v-if="withActions">
          <div class="col-md-12">
            <action-buttons :view="false"
                            :edit-permission="'change_customeraddress'"
                            :delete-permission="'delete_customeraddress'"
                            @editClick="onEditClick"
                            @deleteClick="onRemoveClick"/>
          </div>
        </div>
      </template>
      <no-data-available :height="10" v-else-if="!loader"/>
    </div>
  </div>
</template>

<script>
  import NoDataAvailable from "../../../../core/components/common/NoDataAvailable";
  import ActionButtons from "../../../../core/components/ams-table/ActionButtons";
  import {createNamespacedHelpers} from 'vuex';
  import Spinner from "@/core/components/common/Spinner";

  const {mapActions} = createNamespacedHelpers('customer/customerView');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    components: {ActionButtons, NoDataAvailable, Spinner},
    props: {
      address: {
        type: Object,
        required: true
      },
      type: {
        type: String,
        default: null
      },
      withActions: {
        type: Boolean,
        default: true
      },
      headerText: {
        type: String,
        default: null
      },
      hideIcon: {
        type: Boolean,
        required: false,
        default: false
      },
      showEditAction: {
        type: Boolean,
        required: false,
        default: false
      },
      showCreateAction: {
        type: Boolean,
        required: false,
        default: false
      },
      source: {
        type: String,
        required: false,
        default: null
      },
      loader: {
        type: Boolean,
        default: false
      }
    },
    name: "AddressViewer",
    data: () => {
      return {};
    },
    methods: {
      ...mapActions([
        'showAddressModal',
      ]),
      onEditClick() {
        this.$emit('onEditClick', this.address)
      },
      onRemoveClick() {
        this.$emit('onRemoveClick', this.address)
      }
    },
  }

</script>

<style lang="scss" scoped>
  @import "./../../scss/variables";

  .address-form {
    min-height: 16em;

    .card-body {
      .row {
        .col-sm-5 {
          p {
            font-weight: 500;
            font-size: 1em;
            margin-bottom: .3em;
          }
        }

        .col-sm-7 {
          p {
            font-size: 1em;
            margin-bottom: .3em;
          }
        }
      }
    }
  }

</style>
